import { IRoutes } from "@techzyapp/ui-lib";

// Auth Routes
import { LoginRoute } from "pages/Login/routes";
import { ForgotPasswordRoute } from "pages/ForgotPassword/routes";
import { ResetPasswordRoute } from "pages/ResetPassword/routes";
import { SetPasswordRoute } from "pages/SetPassword/routes";

// Account Routes
import { AccountRoute } from "pages/Account/routes";

// System Users
import { SystemUsersRoute } from "pages/SystemUsers/routes";
import { AuditLogsRoute } from "pages/AuditLogs/routes";

// Customer Management
import { CustomersRoute } from "pages/Customers/routes";
import { CustomerGroupsRoute } from "pages/CustomerGroups/routes";
import { CustomerFeedbackRoute } from "pages/CustomerFeedbacks/routes";

// Content Management
import { TextPagesRoute } from "pages/TextPages/routes";
import { ExploreBannersRoute } from "pages/ExploreBanners/routes";

// Promotions
import { DealsRoute } from "pages/Deals/routes";
import { PromoCodesRoute } from "pages/PromoCodes/routes";
import { ReferralRoute } from "pages/StaticCampaigns/Referral/routes";
import { LoyaltyAnniversaryRoute } from "pages/StaticCampaigns/LoyaltyAnniversary/routes";
import { WelcomeBonusRoute } from "pages/StaticCampaigns/WelcomeBonus/routes";
import { BirthdayRewardRoute } from "pages/StaticCampaigns/BirthdayReward/routes";
import { DynamicCampaignsRoute } from "pages/DynamicCampaigns/routes";

// Finance
import { TransactionsRoute } from "pages/Transactions/routes";
import { PurchasesRoute } from "pages/Purchases/routes";

// Venue Management
import { VenuesRoute } from "pages/Venues/routes";
import { VenueCategoriesRoute } from "pages/VenueCategories/routes";
import { AmenitiesRoute } from "pages/Amenities/routes";

// Tier Management
import { TiersRoute } from "pages/Tiers/routes";

// Config
import { ApplicationUpdateRoute } from "pages/ApplicationUpdate/routes";

// Operations Hub
import { OperatorsRoute } from "pages/Operators/routes";
import { ManagersRoute } from "pages/Managers/routes";

// Club Iveria
import { CasinoConfigRoute } from "pages/CasinoConfig/routes";

// Notifications
import { NotificationTemplatesRoute } from "pages/NotificationTemplates/routes";

export const allRoutes: IRoutes = {
  mainPath: "/",
  defaultPath: TextPagesRoute.path,
  indexElement: TextPagesRoute.element,
  items: [
    {
      name: "System Users",
      path: "/system-users",
      element: "",
      children: [SystemUsersRoute, AuditLogsRoute],
    },
    {
      name: "Customer Management",
      path: "/customer-management",
      element: "",
      children: [CustomersRoute, CustomerGroupsRoute, CustomerFeedbackRoute],
    },
    {
      name: "Finances",
      path: "/finances",
      element: "",
      children: [TransactionsRoute, PurchasesRoute],
    },
    {
      name: "Promotions",
      path: "/promotions",
      element: "",
      children: [
        DealsRoute,
        PromoCodesRoute,
        {
          name: "Static Campaigns",
          path: "/promotions/static-campaigns",
          iconName: "Solana",
          element: "",
          children: [
            ReferralRoute,
            LoyaltyAnniversaryRoute,
            WelcomeBonusRoute,
            BirthdayRewardRoute,
          ],
        },
        DynamicCampaignsRoute,
      ],
    },
    {
      name: "Notifications",
      path: "/notifications",
      element: "",
      children: [NotificationTemplatesRoute],
    },
    {
      name: "Venue Management",
      path: "/venue-management",
      element: "",
      children: [VenuesRoute, AmenitiesRoute, VenueCategoriesRoute],
    },
    {
      name: "Content Management",
      path: "/content-management",
      element: "",
      children: [TextPagesRoute, ExploreBannersRoute],
    },
    {
      name: "Tier Management",
      path: "/tiers",
      element: "",
      children: [TiersRoute],
    },
    {
      name: "Operations Hub",
      path: "/operations-hub",
      element: "",
      children: [ManagersRoute, OperatorsRoute],
    },
    {
      name: "Club Iveria",
      path: "/club-iveria",
      element: "",
      children: [CasinoConfigRoute],
    },
    {
      name: "Config",
      path: "/config",
      element: "",
      children: [ApplicationUpdateRoute],
    },
    AccountRoute,
  ],
};

export const authRoutes: IRoutes = {
  mainPath: "/",
  defaultPath: LoginRoute.path,
  indexElement: LoginRoute.element,
  items: [
    LoginRoute,
    ForgotPasswordRoute,
    ResetPasswordRoute,
    SetPasswordRoute,
  ],
};
